import { render } from "./TableBanner.vue?vue&type=template&id=6a22384b&scoped=true"
import script from "./TableBanner.vue?vue&type=script&lang=js"
export * from "./TableBanner.vue?vue&type=script&lang=js"

import "./TableBanner.vue?vue&type=style&index=0&id=6a22384b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a22384b"]])

export default __exports__